import {debugLog} from "../Utils/LogUtils";
import { useEffect } from 'react';
export default function useClearJointSubscriberForSingleEnrolment(state) {
    //Clear first and lastname of joint subscriber if we are switching to Single enrolment
    useEffect(() => {
        if (!state.enrollment.state) { return; }
        if (!state.common.subscriber2Include) {
            state.setJointSubscriber({
                ...state.jointSubscriber,
                firstName: '',
                lastName: '',
                monthlyIncomeGross: 0,
                monthlyIncomeNet: 0,
                monthlyIncomeNetAfterMat: 0,
                monthlyIncomeGrossAfterMat: 0
            });
        }
        debugLog("useClearJointSubscriberForSingleEnrolment.js");
    }, [state.common.subscriber2Include]);
}